import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    courseUuid: String,
    nextLessonUrl: String,
    nextLessonId: String
  }

  connect() {
    this.handleShowIntro = this.handleShowIntro.bind(this)
    window.addEventListener('lesson-interstitial:showNextIntro', this.handleShowIntro)
  }

  disconnect() {
    window.removeEventListener('lesson-interstitial:showNextIntro', this.handleShowIntro)
  }

  handleShowIntro() {
    this.show()
    this.markIntroAsViewed()
  }

  show() {
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  hide() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }

  startLesson(event) {
    event.preventDefault()
    this.hide()
    window.location.href = this.nextLessonUrlValue
  }

  skipIntro(event) {
    event.preventDefault()
    this.hide()
    window.location.href = this.nextLessonUrlValue
  }

  markIntroAsViewed() {
    if (!this.nextLessonIdValue || !this.courseUuidValue) return

    const url = `/courses/${this.courseUuidValue}/lessons/${this.nextLessonIdValue}/mark_intro_viewed`

    post(url, {
      responseKind: 'json'
    }).then(response => {
      if (!response.ok) {
        console.warn('Failed to mark intro as viewed')
      }
    }).catch(error => {
      console.warn('Error marking intro as viewed:', error)
    })
  }
}
